import { DEFAULT_LANGUAGE, LANGUAGE_LOCAL_STORAGE_KEY } from "src/constants";

export enum LanguageEnum {
    FR = "fr-FR",
    GB = "en-GB",
    ES = "es-ES",
}

export enum LocaleEnum {
    FR = "fr",
    EN = "en",
    GB = "en-gb",
    ES = "es",
}

export enum CalendarLangEnum {
    FR = "fr",
    GB = "enGB",
    ES = "es",
}

const locale =
    (window.localStorage.getItem(LANGUAGE_LOCAL_STORAGE_KEY) as LanguageEnum) ??
    (navigator.language as LanguageEnum) ??
    DEFAULT_LANGUAGE;

export function getLocale(): LanguageEnum {
    return locale;
}

export function getCalendarLocale(locale: LanguageEnum): CalendarLangEnum {
    const langs: Record<LanguageEnum, CalendarLangEnum> = {
        [LanguageEnum.FR]: CalendarLangEnum.FR,
        [LanguageEnum.GB]: CalendarLangEnum.GB,
        [LanguageEnum.ES]: CalendarLangEnum.ES,
    };

    return langs[locale];
}

export function setLocale(locale: LanguageEnum): void {
    window.localStorage.setItem(LANGUAGE_LOCAL_STORAGE_KEY, locale);
}
